import { TABLE_ROWS_PER_PAGE } from 'lib/tableLib'
import { useCallback, useEffect, useState } from 'react'

const ITEMS = []

function useTablePagination({
  rowsPerPage = TABLE_ROWS_PER_PAGE,
  page = 0,
  items = ITEMS,
} = {}) {
  const [newRowsPerPage, setNewRowsPerPage] = useState(rowsPerPage)
  const [newPage, setNewPage] = useState(page)

  const [pagedItems, setPagedItems] = useState([])

  useEffect(
    () =>
      setPagedItems(
        items.slice(newPage * newRowsPerPage, (newPage + 1) * newRowsPerPage)
      ),
    [setPagedItems, items, newPage, newRowsPerPage]
  )

  const handleChangePage = useCallback(
    (event, newPage) => {
      setNewPage(newPage)
    },
    [setNewPage]
  )

  const handleChangeRowsPerPage = useCallback(
    (event) => {
      setNewRowsPerPage(parseInt(event.target.value, 10))
      setNewPage(0)
    },
    [setNewRowsPerPage, setNewPage]
  )

  return {
    page: newPage,
    rowsPerPage: newRowsPerPage,
    setPage: setNewPage,
    pagedItems,
    handleChangePage,
    handleChangeRowsPerPage,
  }
}

export default useTablePagination
